//MUI
import Menu from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

//common
import MyLink from 'common/components/MyLink';
import { LogoImage, LogoTextSrc, G_Map, ModuleTextSrc, FSOL } from 'svg';
import { getBrand, brandLogoUrl } from 'config/brand';
import { setOpenAsideBarMobile } from '@redux/cacheReducer';
import { HEADER_PORTAL_ID, HEADER_TOOLBAR_PORTAL_ID } from 'layout/main/constants';
import useGeneralHook from 'common/hook/useGeneralHook';
import { ROUTES_PATH } from 'layout/constants';

//screen
import ProfileBox from 'layout/main/ProfileBox';

const DefaultHeader = () => {
  const { dispatch, isMobile, pathname } = useGeneralHook();

  const renderRouteIcon = () => {
    const gMapRoute = pathname.includes(ROUTES_PATH.menuMap.index);
    const fsolRoute =
      pathname.includes(ROUTES_PATH.supplier.index) ||
      pathname.includes(ROUTES_PATH.quickSearch.index);

    if (gMapRoute) return <G_Map />;
    if (fsolRoute) return <FSOL />;
    return <ModuleTextSrc />;
  };

  return (
    <>
      <Box
        className="flex items-center tablet:px-4 gap-2 tablet:gap-4 z-10 px-2"
        sx={{
          bgcolor: 'background.paper',
          borderBottom: 1,
          borderColor: 'divider',
          minHeight: 54,
        }}
      >
        {isMobile ? (
          <>
            <Button
              variant="outlined"
              sx={{ p: 1, height: 40 }}
              onClick={() => {
                dispatch(setOpenAsideBarMobile());
              }}
            >
              <Menu />
            </Button>
            <MyLink to="/" aria-label="Link to HomePage">
              <Box className="flex items-center w-full justify-center">
                {getBrand().has_logo ? (
                  <img
                    src={brandLogoUrl()}
                    alt="logo"
                    style={{ height: 50, maxWidth: 150, objectFit: 'contain' }}
                  />
                ) : (
                  <>
                    <LogoImage style={{ height: 50, width: 50 }} />
                    <LogoTextSrc style={{ width: 100, marginLeft: 2 }} />
                  </>
                )}
              </Box>
            </MyLink>
            <Box
              className="flex items-center flex-1 overflow-auto gap-2 tablet:gap-4 h-full"
              id={HEADER_PORTAL_ID}
            />
          </>
        ) : (
          <>
            {renderRouteIcon()}
            <Box
              className="flex items-center flex-1 overflow-auto gap-2 tablet:gap-4 h-full"
              id={HEADER_PORTAL_ID}
            />
          </>
        )}
        {!isMobile && <ProfileBox />}
      </Box>
      {isMobile && <Box id={HEADER_TOOLBAR_PORTAL_ID} bgcolor={'background.paper'} />}
    </>
  );
};

export default DefaultHeader;
